<template lang="pug">
system-tabs(section="/system/team")
    el-card.contains-table(shadow="always")
        team-list(scope="system")
</template>

<script>
import SystemTabs from '@/views/system/Partials/Tabs';
import TeamList from '@/views/system/Team/List';

/**
 * Chrome only. `/system/team` renders its own tab bar so the detail page below
 * it can put buttons there, the same arrangement the project screens use.
 */
export default {
    name: 'SystemTeamList',
    components: {
        SystemTabs,
        'team-list': TeamList,
    },
};
</script>
